import { useEffect, useMemo, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"
import { Resource, Scope } from "@/constants/permission"

import { useCustomerQuery } from "@/hook/Dictionaries/Customers/useCustomerQuery"
import { useDepotQuery } from "@/hook/Dictionaries/useDepotQuery"
import { useFinanceDocumentTypeQuery } from "@/hook/Finance/useFinanceDocumentTypeQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"
import { usePermission } from "@/hook/usePermission"

import { FINANCE_DOCUMENT_KEY } from "@/types/IFinanceDataRecord"
import { FilterField, FilterFieldOperator, FilterFieldType } from "@/types/ui"


export const useFinanceDocumentFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: FINANCE_DOCUMENT_KEY
  })

  const oldFilters: FieldData[] = getFilter()

  const { data: documentTypes } = useFinanceDocumentTypeQuery()
  const { data: depots } = useDepotQuery()
  const { data: customers } = useCustomerQuery()

  const { hasPermission } = usePermission()
  
  const isAdminOrManager = useMemo(() => {
      return hasPermission(Resource.OrderReport, Scope.Read)
    }, [hasPermission])

  useEffect(() => {
    let filters = [
      ...FinanceDocumentFilters, 
      {
        text: "Тип документа",
        name: "documentType",
        type: FilterFieldType.Select,
        values: documentTypes,
        hidden: true
      },
      {
        text: "Нефтебаза",
        name: "DepotId",
        type: FilterFieldType.Select,
        values: depots?.response.data
      }
    ]

    if (isAdminOrManager) {
      filters = [
        ...filters,
        {
          text: "Контрагент",
          name: "CustomerId",
          type: FilterFieldType.Select,
          values: customers?.response.data
        }
      ]
    }

    setFilters(filters)
  }, [customers])

  return mapFilters(filters, oldFilters)
}

const FinanceDocumentFilters: FilterField[] = [
  {
    text: "Номер",
    name: "Number",
    operator: FilterFieldOperator.Contains,
    type: FilterFieldType.Text
  },
  {
    text: "Префикс",
    name: "Prefix",
    operator: FilterFieldOperator.Contains,
    type: FilterFieldType.Text
  },
  {
    text: "Договор",
    name: "Contract",
    operator: FilterFieldOperator.Contains,
    type: FilterFieldType.Text
  },
  {
    text: "Документ основание",
    name: "BaseDocument",
    operator: FilterFieldOperator.Contains,
    type: FilterFieldType.Text
  },
  {
    text: "Дата",
    name: "Date",
    type: FilterFieldType.DateRange,
    hidden: true
  }
]